import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DashboardManagerRoutingModule} from './dashboard-manager-routing.module';
import {DashboardManagerComponent} from './dashboard-manager.component';
import {DxDashboardControlModule} from 'devexpress-dashboard-angular';
import {DevExtremeModule, DxTextBoxModule} from 'devextreme-angular';
import {DxoPopupModule} from 'devextreme-angular/ui/nested';
import {RouterOutlet} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {BiDashboardModule} from 'src/app/widgets/bi-dashboard/bi-dashboard.module';
import {DashboardAccessControlModule} from 'src/app/widgets/dashboard-access-control/dashboard-access-control.module';

@NgModule({
	declarations: [
		DashboardManagerComponent,
	],
	imports: [
		CommonModule,
		RouterOutlet,
		FontAwesomeModule,
		BiDashboardModule,
		DashboardManagerRoutingModule,
		DxDashboardControlModule,
		DevExtremeModule,
		DxoPopupModule,
		DxTextBoxModule,
		DashboardAccessControlModule,
	],
})
export class DashboardManagerModule { }